import { render, staticRenderFns } from "./textnumber.vue?vue&type=template&id=022e65b2&scoped=true"
import script from "./textnumber.vue?vue&type=script&lang=js"
export * from "./textnumber.vue?vue&type=script&lang=js"
import style0 from "./textnumber.vue?vue&type=style&index=0&id=022e65b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e65b2",
  null
  
)

export default component.exports